// Synthetic car-wash demo data.

export const packages = [
  { id: 'basic', name: 'Express Wash', price: 250, duration: '20 min', description: 'Exterior rinse, foam, dry.', color: 'bg-sky-500' },
  { id: 'standard', name: 'Premium Clean', price: 450, duration: '35 min', description: 'Exterior + vacuum + windows.', color: 'bg-blue-600' },
  { id: 'deluxe', name: 'Full Detail', price: 850, duration: '60 min', description: 'Interior detail, wax, tires.', color: 'bg-indigo-600' },
]

export const timeSlots = [
  '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
  '11:00', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00',
]

export const vehicles = [
  { id: 'sedan', label: 'Sedan', multiplier: 1 },
  { id: 'suv', label: 'SUV / MPV', multiplier: 1.25 },
  { id: 'pickup', label: 'Pickup', multiplier: 1.35 },
  { id: 'motorcycle', label: 'Motorcycle', multiplier: 0.6 },
]
